import React from 'react';
import Typography from '@mui/material/Typography';
import { makeStyles } from '~/tools/makeStyles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  messageContainer: {
    textAlign: 'center',
    marginBottom: 16,
  },
  message: {
    fontSize: 32,
    color: theme.palette.mainaccent,
  },
}));

const ExpiredPage = () => {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.messageContainer}>
        <Typography className={styles.message}>{t('survey.expired.greeting')}</Typography>
        <Typography>{t('survey.expired.message')}</Typography>
      </div>
    </div>
  );
};

export default ExpiredPage;
